import styled from "styled-components";

import { stylesGlobalDefault } from "global/globalStyle";

export const Container = styled.div`
  position: relative;
  z-index: 10;
`;

export const Selected = styled.button`
  display: flex;
  align-items: center;
  gap: 6px;
  background: transparent;
  border: 1px solid ${stylesGlobalDefault.inputsBorderFocusOff};
  border-radius: 6px;
  padding: 6px 12px;
  font-size: 13px;
  color: ${stylesGlobalDefault.gray};
  cursor: pointer;
  transition: border-color 0.2s;

  &:hover {
    border-color: ${stylesGlobalDefault.blue};
  }

  span {
    font-size: 10px;
  }
`;

export const Dropdown = styled.div`
  position: absolute;
  top: calc(100% + 4px);
  right: 0;
  min-width: 160px;
  background: white;
  border: 1px solid ${stylesGlobalDefault.inputsBorderFocusOff};
  border-radius: 6px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  overflow: hidden;
`;

export const Option = styled.button<{ $active: boolean }>`
  display: block;
  width: 100%;
  padding: 8px 12px;
  border: none;
  background: ${({ $active }) => ($active ? "#E4F1FA" : "transparent")};
  font-size: 13px;
  color: ${stylesGlobalDefault.blackMenu1};
  cursor: pointer;
  text-align: left;

  &:hover {
    background: ${stylesGlobalDefault.backgroundListItemColor};
  }
`;
